export default "__VITE_ASSET__KVR3NXck__"